import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Phone, MapPin, Send } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { useToast } from '../hooks/use-toast';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const { toast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
      const response = await fetch(`${API_URL}/api/contact/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast({
          title: "Message Sent!",
          description: "We'll get back to you within 24 hours. Jazakallahu Khairan!",
        });
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        toast({
          title: "Error",
          description: data.detail || "Failed to send message. Please try again.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Contact form error:', error);
      toast({
        title: "Error",
        description: "Failed to send message. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="w-full px-2 py-12">
        <Link to="/" className="inline-flex items-center text-gray-600 hover:text-navy-500 mb-6">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
        <p className="text-gray-600 mb-8">
          Have questions? We're here to help! Reach out to our support team.
        </p>

        {/* Direct Email Contact - Highlighted */}
        <Card className="bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-200">
          <CardContent className="p-8">
            <div className="text-center mb-8">
              <Mail className="w-16 h-16 text-navy-500 mx-auto mb-4" />
              <h2 className="text-3xl font-bold text-gray-900 mb-3">Need Help with Registration?</h2>
              <p className="text-gray-600 text-lg mb-6">
                Email us directly for immediate assistance with any questions or concerns
              </p>
            </div>
            
            <div className="text-center">
              <a 
                href="mailto:info@qbool.ca"
                className="inline-flex items-center gap-3 bg-mint-500 hover:bg-mint-600 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors shadow-lg hover:shadow-xl"
              >
                <Mail className="w-6 h-6" />
                info@qbool.ca
              </a>
              <p className="text-sm text-gray-500 mt-4">
                Click to open your email client or copy the address above
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ContactPage;